/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './aerations-admin.scss';

/* eslint-disable import/no-unresolved, import/default */

import aerationsAdminTemplate from './aerations-admin.tpl.html';
import addAerationTemplate from './add-aeration.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.admin.aerationsAdmin', [])
    .directive('agAerationsAdmin', AerationsAdmin)
    .name;

/*@ngInject*/
function AerationsAdmin() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '='
        },
        controller: AerationsAdminController,
        controllerAs: 'vm',
        templateUrl: aerationsAdminTemplate
    };
}

/* eslint-disable angular/angularelement */


/*@ngInject*/
function AerationsAdminController($rootScope, $scope, $document, $mdDialog, $q, $filter, $mdMedia,
                              $translate, agTypes, types, userService, assetService, aerationService) {

    let vm = this;

    vm.agTypes = agTypes;

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN';
    vm.hasData = false;

    vm.aerations = [];
    vm.aerationsCount = 0;
    vm.allAerations = [];
    vm.selectedAerations = [];

    vm.displayPagination = true;

    vm.currentAeration = null;

    vm.query = {
        order: 'name',
        limit: 5,
        page: 1,
        search: null
    };

    vm.addAerationAction = {
        name: 'ag.aeration.add',
        show: true,
        onAction: function($event) {
            vm.addAeration($event);
        },
        icon: 'add'
    };

    vm.searchAction = {
        name: 'action.search',
        show: true,
        onAction: function() {
            vm.enterFilterMode();
        },
        icon: 'search'
    };

    vm.refreshAction = {
        name: 'action.refresh',
        show: true,
        onAction: function() {
            vm.reloadAerations();
        },
        icon: 'refresh'
    };

    vm.onRowClick = onRowClick;
    vm.isCurrent = isCurrent;
    vm.enterFilterMode = enterFilterMode;
    vm.exitFilterMode = exitFilterMode;
    vm.onReorder = onReorder;
    vm.onPaginate = onPaginate;
    vm.addAeration = addAeration;
    vm.deleteAerationRelation = deleteAerationRelation;
    vm.deleteAerationRelations = deleteAerationRelations;
    vm.reloadAerations = reloadAerations;
    vm.updateAerations = updateAerations;

    $scope.$watch(function() { return $mdMedia('gt-xs'); }, function(isGtXs) {
        vm.isGtXs = isGtXs;
    });

    $scope.$watch(function() { return $mdMedia('gt-md'); }, function(isGtMd) {
        vm.isGtMd = isGtMd;
        if (vm.isGtMd) {
            vm.limitOptions = [5, 10, 15];
        } else {
            vm.limitOptions = null;
        }
    });

    $scope.$watch('vm.ctx', function() {
        if (vm.showData && vm.ctx) {
            vm.isEdit = vm.ctx.isEdit;
            vm.assetId = null;
            if (vm.ctx.stateController) {
                vm.assetId = vm.ctx.stateController.getStateParams().entityId;
            }
            vm.ctx.widgetActions = [ vm.addAerationAction, vm.searchAction, vm.refreshAction ];
            vm.ctx.widgetTitle = $translate.instant('ag.aeration.aerations') + '';
            vm.displayPagination = angular.isDefined(vm.ctx.settings.displayPagination) ? vm.ctx.settings.displayPagination : true;
            reloadAerations();
        }
    });

    $scope.$on('editModeChanged', function() {
        vm.isEdit = vm.ctx.isEdit;
    });

    $scope.$watch("vm.query.search", function(newVal, prevVal) {
        if (!angular.equals(newVal, prevVal) && vm.query.search != null) {
            updateAerations();
        }
    });

    $scope.$on('aerationUpdated', function(event, aeration) {
        var result = $filter('filter')(vm.allAerations, {id: { id: aeration.id.id } }, true);
        if (result && result.length) {
            var prevAeration = result[0];
            var index = vm.allAerations.indexOf(prevAeration);
            vm.allAerations[index] = aeration;
            index = vm.aerations.indexOf(prevAeration);
            if (index > -1) {
                vm.aerations[index] = aeration;
            }
        }
    });

    $scope.$watch('vm.selectedAerations.length', function (newLength) {
        var selectionMode = newLength ? true : false;
        if (vm.ctx) {
            if (selectionMode) {
                vm.ctx.hideTitlePanel = true;
            } else if (vm.query.search == null) {
                vm.ctx.hideTitlePanel = false;
            }
        }
    });

    function onRowClick($event, aeration) {
        if (vm.currentAeration != aeration) {
            vm.currentAeration = aeration;
        }
        vm.ctx.stateController.openRightLayout();
        broadcastUnitSelected(aeration);
    }

    function broadcastUnitSelected(unit) {
        var entityId = unit ? unit.id : null;
        var entitySubtype = unit ? unit.type : null;
        var entityName = unit ? unit.name : null;
        $rootScope.$broadcast('assetUnitSelected', entityId, entitySubtype, entityName, vm.assetId, vm.assetType);
    }

    function isCurrent(aeration) {
        return (vm.currentAeration && aeration) &&
            (vm.currentAeration.id.id === aeration.id.id);
    }

    function enterFilterMode () {
        vm.query.search = '';
        vm.ctx.hideTitlePanel = true;
    }

    function exitFilterMode () {
        vm.query.search = null;
        updateAerations();
        vm.ctx.hideTitlePanel = false;
    }

    function onReorder () {
        updateAerations();
    }

    function onPaginate () {
        updateAerations();
    }

    function addAeration($event) {
        if ($event) {
            $event.stopPropagation();
        }
        var excludeEntityIds = [];
        vm.allAerations.forEach(function(aeration) {
            excludeEntityIds.push(aeration.id.id);
        });

        var stateParams = vm.ctx.stateController.getStateParamsByStateId(agTypes.adminState.site);
        var siteId = stateParams.entityId;

        $mdDialog.show({
            controller: AddAerationController,
            controllerAs: 'vm',
            templateUrl: addAerationTemplate,
            parent: angular.element($document[0].body),
            locals: {
                excludeEntityIds: excludeEntityIds,
                siteId: siteId,
                assetId: vm.assetId
            },
            fullscreen: true,
            targetEvent: $event
        }).then(function () {
            reloadAerations();
        }, function () {
        });
    }

    function deleteAerationRelation($event, aeration) {
        if ($event) {
            $event.stopPropagation();
        }
        if (aeration) {
            var name = aeration.name;
            var title = $translate.instant('ag.aeration.delete-aeration-relation-title', {aerationName: name});
            var content = $translate.instant('ag.aeration.delete-aeration-relation-text');
            var confirm = $mdDialog.confirm()
                .targetEvent($event)
                .title(title)
                .htmlContent(content)
                .ariaLabel(title)
                .cancel($translate.instant('action.no'))
                .ok($translate.instant('action.yes'));
            $mdDialog.show(confirm).then(function () {
                aerationService.deleteAerationRelation(aeration.id, vm.assetId).then(
                    function success() {
                        reloadAerations();
                    }
                );
            });
        }
    }

    function deleteAerationRelations($event) {
        if ($event) {
            $event.stopPropagation();
        }
        if (vm.selectedAerations && vm.selectedAerations.length > 0) {
            var title = $translate.instant('ag.aeration.delete-aeration-relations-title', {count: vm.selectedAerations.length}, 'messageformat');
            var content = $translate.instant('ag.aeration.delete-aeration-relations-text');
            var confirm = $mdDialog.confirm()
                .targetEvent($event)
                .title(title)
                .htmlContent(content)
                .ariaLabel(title)
                .cancel($translate.instant('action.no'))
                .ok($translate.instant('action.yes'));
            $mdDialog.show(confirm).then(function () {
                var tasks = [];
                for (var i=0;i<vm.selectedAerations.length;i++) {
                    var aeration = vm.selectedAerations[i];
                    tasks.push(aerationService.deleteAerationRelation(aeration.id, vm.assetId));
                }
                $q.all(tasks).then(function () {
                    reloadAerations();
                });

            });
        }
    }

    function reloadAerations (keepSelection) {
        vm.allAerations.length = 0;
        vm.aerations.length = 0;
        if (!keepSelection) {
            vm.currentAeration = null;
        }
        if (vm.assetId) {
            assetService.getAsset(vm.assetId.id).then(
                function success(asset) {
                    vm.assetType = asset.type;
                    vm.aerationsPromise = aerationService.getAssetAerations(vm.assetId);
                    vm.aerationsPromise.then(
                        function success(allAerations) {
                            vm.allAerations = allAerations;
                            vm.selectedAerations = [];
                            vm.updateAerations();
                            vm.aerationsPromise = null;
                        },
                        function fail() {
                            vm.allAerations = [];
                            vm.selectedAerations = [];
                            vm.updateAerations();
                            vm.aerationsPromise = null;
                        }
                    )
                },
                function fail() {
                    vm.assetId = null;
                    vm.assetType = null;
                    vm.updateAerations();
                }
            );
        } else {
            vm.assetType = null;
            vm.updateAerations();
        }
    }

    function updateAerations () {
        vm.selectedAerations = [];
        var result = $filter('orderBy')(vm.allAerations, vm.query.order);
        if (vm.query.search != null) {
            result = $filter('filter')(result, {$: vm.query.search});
        }
        vm.aerationsCount = result.length;

        if (vm.displayPagination) {
            var startIndex = vm.query.limit * (vm.query.page - 1);
            vm.aerations = result.slice(startIndex, startIndex + vm.query.limit);
        } else {
            vm.aerations = result;
        }
    }

}

/*@ngInject*/
function AddAerationController($scope, $mdDialog, types, agTypes, entityRelationService, siteId, assetId, excludeEntityIds) {

    var vm = this;

    vm.types = types;
    vm.agTypes = agTypes;
    vm.excludeEntityIds = excludeEntityIds;
    vm.assetId = assetId;
    vm.siteId = siteId;

    vm.add = add;
    vm.cancel = cancel;

    function cancel() {
        $mdDialog.cancel();
    }

    function add() {
        var relation = {
            from: vm.targetAerationId,
            to: vm.assetId,
            type: agTypes.relationType.aerationSystem,
            additionalInfo: {
            }
        };
        entityRelationService.saveRelation(relation).then(
            function success() {
                $scope.theForm.$setPristine();
                $mdDialog.hide();
            }
        );
    }
}